import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Space,
  Popconfirm,
  message,
  ConfigProvider,
  Tag,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  BgColorsOutlined,
} from "@ant-design/icons";
import "./color.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const ColorVariants = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();

  const fetchColors = () => {
    callApi(
      "GET",
      routes.colorVariant,
      null,
      setLoading,
      (res) => {
        console.log("res of data ", res);
        setData(res?.data?.variantColors || res?.data || []);
      },
      (err) => message.error("Failed to fetch colors")
    );
  };

  useEffect(() => {
    fetchColors();
  }, []);

  const showModal = (item = null) => {
    setEditingItem(item);
    if (item) {
      form.setFieldsValue(item);
    } else {
      form.resetFields();
    }
    setIsModalOpen(true);
  };

  const handleProcess = (values) => {
    const method = editingItem ? "PATCH" : "POST";
    const url = editingItem
      ? `${routes.colorVariant}/${editingItem._id}`
      : routes.colorVariant;

    callApi(
      method,
      url,
      values,
      setLoading,
      () => {
        message.success(
          `Color ${editingItem ? "updated" : "added"} successfully`
        );
        setIsModalOpen(false);
        fetchColors();
      },
      (err) => message.error("Operation failed")
    );
  };

  const handleDelete = (id) => {
    callApi("DELETE", `${routes.colorVariant}/${id}`, null, setLoading, () => {
      message.success("Color deleted");
      fetchColors();
    });
  };

  const columns = [
    {
      title: "Color Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (active) => (
        <Tag color={active ? "orange" : "default"} className="active-tag">
          {active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <EditOutlined
            className="edit-action"
            style={{ color: "#FFA450", cursor: "pointer" }}
            onClick={() => showModal(record)}
          />
          <Popconfirm
            title="Delete this color?"
            onConfirm={() => handleDelete(record._id)}
          >
            <DeleteOutlined className="delete-action" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FFA450" } }}>
      <div className="user-table-container">
        <div className="variant-header">
          <h2>Color Variants</h2>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => showModal()}
          >
            Add New Color
          </Button>
        </div>

        <Table
          dataSource={data}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />

        <Modal
          title={editingItem ? "Edit Color Variant" : "Add Color Variant"}
          open={isModalOpen}
          onOk={() => form.submit()}
          onCancel={() => setIsModalOpen(false)}
          confirmLoading={loading}
          okText={editingItem ? "Update" : "Add"}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleProcess}
            initialValues={{ isActive: true }}
          >
            <Form.Item
              name="name"
              label="Color Name (e.g. Red, Blue, Yellow)"
              rules={[{ required: true, message: "Please enter color name" }]}
            >
              <Input placeholder="Enter color name" />
            </Form.Item>
            <Form.Item name="isActive" label="Status" valuePropName="checked">
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </ConfigProvider>
  );
};

export default ColorVariants;

